import axios from 'axios';

export default {
    pre_insercion(p_email, p_usuario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_indemniza.pre_insercion",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
				  })
			})
	},
    
    recuperar(p_email, p_usuario, p_fecpago, p_asegurado, p_beneficiario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_indemniza.recuperar",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_fecpago": p_fecpago,
					"p_asegurado": p_asegurado,
					"p_beneficiario": p_beneficiario
				  })
			})
	},

	nombre_asegurado(p_email, p_usuario, p_asegurado) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_indemniza.nombre_asegurado",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_asegurado": p_asegurado
				  })
			})
	},

	nombre_beneficiario(p_email, p_usuario, p_beneficiario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_indemniza.nombre_beneficiario",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_beneficiario": p_beneficiario
				  })
			})
	},

	rechazar(p_email, p_usuario, p_siniestro) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_indemniza.Fnc_QuitarVB",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_siniestro": p_siniestro
				  })
			})
	},

	indemnizar(p_email, p_usuario, p_siniestro, p_fecpago) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_indemniza.indemnizar",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_siniestro": p_siniestro,
					"p_fecpago": p_fecpago
				  })
			})
	},

	beneficiarios(p_email, p_usuario, p_siniestro) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_indemniza.monto_beneficiarios",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_siniestro": p_siniestro
				  })
			})
	},

}